/** Values are the Remote Config parameter keys. */
export const FeatureFlag = {
  Budget: "feature_budget_enabled",
  Recurring: "feature_recurring_enabled",
  TaxPlanner: "feature_tax_planner_enabled",
} as const;
export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];

export type FeatureFlags = Record<FeatureFlag, boolean>;

/** Used until Remote Config answers, and when it fails: current behavior (everything on). */
export const DEFAULT_FLAGS: FeatureFlags = {
  [FeatureFlag.Budget]: true,
  [FeatureFlag.Recurring]: true,
  [FeatureFlag.TaxPlanner]: true,
};
